<template>
  <div>
    <v-select
      class="mt-3"
      id="local_organization"
      v-if="localOrganizations.length > 0"
      :items="localOrganizations"
      label="Местна организация"
      :value="value"
      @change="update"
      solo
      clearable
    ></v-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'LocalOrganizationsSelect',
  props: ['value'],
  mounted () {
    if (this.isMember) {
      this.$store.dispatch('getLocalOrganizations')
    }

  },
  methods: {
    update (val) {
      this.$emit('input', val)
    }
  },
  computed: {
    ...mapGetters(['isMember']),
    localOrganizations () {
      return this.$store.getters.localOrganizations.map(org => {
        return { text: org.name, value: org.id }
      })
    },
  }
}
</script>
